import React from "react";
import "../../styles/AboutUsHeroSection.css"; // Import the CSS file

const AboutUsHeroSection = () => {
  return (
    <section className="about-section">
      <div className="about-header">
        <p className="welcome-text">Welcome, We're</p>
        <h1 className="company-name">Greenwork Consulting</h1>
      </div>
    </section>
  );
};

export default AboutUsHeroSection;
